import { Info } from 'react-feather'

import DateRangeDropdown from './DateRangeDropdown/DateRangeDropdown'
import DeviceDropdown from './DeviceDropdown/DeviceDropdown'
import { DomainSelector, Tooltip } from '@pepper/ui'

import s from './Filters.module.css'

interface Props {
  companyId: string
}

const Filters = ({ companyId }: Props) => {
  return (
    <div className={s.wrapper}>
      <DomainSelector
        companyId={companyId}
        isControlled={false}
        size="regular"
      />
      <DateRangeDropdown />
      <div className={s.deviceTooltipContainer}>
        <DeviceDropdown />
        <Tooltip
          placement="bottomRight"
          title="To ensure accuracy, the dashboard refreshes every Thursday, syncing with Google Search Console."
        >
          <Info size={16} color="var(--color-gray-600)" />
        </Tooltip>
      </div>
    </div>
  )
}

export default Filters
